// SCREENS-VIEWER: the real RFB client, noVNC (pinned `@novnc/novnc` 1.7.0), loaded on first use
// so the Screens page does not carry it until a screen is shown. Tests pass their own factory
// through `RfbFactoryContext`.
import { createContext } from "react";
import type { CreateRfb, RfbLike } from "./live-connection";

export const createNoVncRfb: CreateRfb = async (target, url, options) => {
  const { default: RFB } = await import("@novnc/novnc");
  return new RFB(target, url, options) as unknown as RfbLike;
};

/** The RFB factory the viewer uses; null = noVNC over the real relay (the HTTP API only). */
export const RfbFactoryContext = createContext<CreateRfb | null>(null);
